export default __webpack_public_path__ + "static/media/egg2aud.4a136f66.mp3";